import { render } from "./PlatformFeeAllowanceWarning.vue?vue&type=template&id=b74120c8&scoped=true"
import script from "./PlatformFeeAllowanceWarning.vue?vue&type=script&lang=js"
export * from "./PlatformFeeAllowanceWarning.vue?vue&type=script&lang=js"

import "./PlatformFeeAllowanceWarning.vue?vue&type=style&index=0&id=b74120c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74120c8"]])

export default __exports__